import { render, staticRenderFns } from "./tempates.vue?vue&type=template&id=011a0d73&"
import script from "./tempates.vue?vue&type=script&lang=js&"
export * from "./tempates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports